// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6726f335","70":"9ccf4416","101":"1efc0854","453":"e05a4f9f","533":"003c9e39","576":"f3fb0491","654":"a8d8581c","678":"c49c2364","774":"bec08cd5"}[chunkId] + ".chunk.js";
};